import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons'
import { Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useImmer } from 'use-immer'
import {
  Button,
  Card,
  Col,
  ContentBody,
  ContentHeader,
  ListItem,
  Modal,
  OpportunityForm,
  Row,
  Table,
  useAuthContext
} from '../../../core/components'
import { situationControl } from '../../../core/utils/situationConst'
import { Pagination } from '../../../entities'
import { Product } from '../../../entities/product'
import useOpportunityCreate from '../../../services/mutations/useOpportunityCreate'
import useOrderCreate from '../../../services/mutations/useOrderCreate'
import useContract from '../../../services/queries/contract/useContract'
import useContractItems from '../../../services/queries/contract/useContractItems'
import useContractOpportunities from '../../../services/queries/contract/useContractOpportunities'
import { formatCurrency } from '../../../utils/format/currencyFormat'
import { dateFormat } from '../../../utils/format/dateFormat'
import { dateTimeFormat } from '../../../utils/format/dateTimeFormat'

const { TabPane } = Tabs

const columns = [
  {
    title: 'Nº Oportunidade',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Evento (Origem do Contato)',
    dataIndex: 'event',
    key: 'event',
    render: (value: any) => {
      return value.name
    }
  },
  // {
  //   title: 'Campanha',
  //   dataIndex: 'campaign',
  //   key: 'campaign'
  // },
  {
    title: 'Conceito',
    dataIndex: 'concept',
    key: 'concept',
    render: (value: any) => {
      return value.name
    }
  },
  {
    title: 'Previsão da Venda',
    dataIndex: 'salesForecast',
    key: 'salesForecast',
    render: (value: string) => (value ? dateFormat(value) : '')
  },
  {
    title: 'Data/Hora',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (value: string) => dateTimeFormat(value)
  }
]

const itemsColumns = [
  {
    title: 'Descrição',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: 'Valor',
    dataIndex: 'value',
    key: 'value',
    render: (value: number) => formatCurrency(value)
  }
]

const opportunityDefaultValue = {
  businessUnityId: '',
  customerId: '',
  sellerId: '',
  marketId: '',
  situationId: '10',
  contacterId: '',
  contact: '',
  status: 'E',
  nextContact: '',
  salesForecast: '',
  proposalValidity: '',
  eventId: '',
  conceptId: '',
  orderId: ''
  // campaignId: ''
}

const orderDefaultValues = {
  customerId: '',
  salesmanId: '',
  budgetId: '',
  paymentMethodId: '',
  paymentTermId: '',
  businessUnitId: '',
  shippingType: '0',
  statusId: '10',
  invoiceType: 'N',
  total: '',
  approved: 0,
  canceled: 0,
  observation: '',
  deliveryDate: '',
  approvedDate: '',
  items: []
}

const contractDefaultValue = {
  customerId: '',
  description: '',
  total: ''
}

const formDefaultValues = {
  opportunity: opportunityDefaultValue,
  order: orderDefaultValues,
  contract: contractDefaultValue,
  temp: { address: '' }
}

export const DetailContractPage = () => {
  const { goBack } = useHistory()
  const { id }: any = useParams()
  const { data: contract, error }: any = useContract(id)
  const { user } = useAuthContext()
  const [formValues, setFormValues] = useImmer(formDefaultValues)
  const { mutateAsync: orderMutate, reset: orderReset } = useOrderCreate()
  const { mutateAsync: opportunityMutate } = useOpportunityCreate()
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const { data: opportunity, opportunityError }: any = useContractOpportunities(
    {
      ...pagination,
      id
    }
  )

  const { data: contractItem, error: contractItemsError }: any =
    useContractItems({
      ...pagination,
      id
    })

  console.log(contractItem?.data)

  useEffect(() => {
    setFormValues((draft) => {
      draft.opportunity.customerId = contract?.data?.customer?.id
    })
    console.log(contract?.data?.customer?.id)
    setFormValues((draft) => {
      draft.contract.customerId = contract?.data?.customer?.id
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract])

  const [isModalVisible, setIsModalVisible] = useState(false)

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  function getSituationControl(key: any) {
    return situationControl[key]
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  const handleSubmit = async () => {
    if (formValues.order.items.length > 0 && formValues.order.paymentMethodId) {
      const items = formValues.order.items.map(
        (item: Product, index: number) => ({
          ...item,
          sequence: index + 1,
          productId: item.id,
          quantity: 1,
          salePrice: item.price,
          defaultPrice: item.price,
          priceListId: '',
          discountPercent: 0
        })
      )
      const orderID = await orderMutate({
        ...formValues.order,
        items,
        salesmanId: user?.id || '',
        customerId: formValues.opportunity.customerId,
        businessUnitId: formValues.opportunity.businessUnityId,
        total: formValues.order.items?.reduce(
          (acc: any, cur: any) => acc + cur.price,
          0
        )
      })
      await opportunityMutate({
        ...formValues.opportunity,
        contacterId: user?.id || '',
        sellerId: user?.id || '',
        orderId: orderID?.data || ''
      })
    } else {
      await opportunityMutate({
        ...formValues.opportunity,
        contacterId: user?.id || '',
        sellerId: user?.id || ''
      })
    }
    orderReset()
    goBack()
    setFormValues(formDefaultValues)
  }

  const handleOk = () => {
    handleSubmit()
    setIsModalVisible(false)
  }

  const handleReset = () => {
    const customer = formValues.opportunity.customerId
    const bu = formValues.opportunity.businessUnityId

    setFormValues(() => ({
      ...formDefaultValues,
      opportunity: { customerId: customer, businessUnityId: bu },
      order: { businessUnitId: bu }
    }))
  }
  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  if (opportunityError) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  if (contractItemsError) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  const GeneralTab = () => {
    return (
      <>
        <Card>
          <div style={{ fontSize: '16px' }}>
            <Row>
              <Col span={12}>
                <ListItem label="Nº Contrato">{contract?.data.id}</ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Descrição">
                  {contract?.data.description}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Situação">
                  {getSituationControl(contract?.data.situation)}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Data Início">
                  {dateTimeFormat(contract?.data.startDate)}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Data Final">
                  {dateFormat(contract?.data.endDate)}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Cliente">
                  {contract?.data.customer.name}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Endereço">
                  {`${contract?.data.customer.addresses[0].address},
                      ${contract?.data.customer.addresses[0].number} -
                      ${contract?.data.customer.addresses[0].district},
                      ${contract?.data.customer.addresses[0].city} -
                      ${contract?.data.customer.addresses[0].state},
                      ${contract?.data.customer.addresses[0].zipCode}`}
                </ListItem>
              </Col>
              <Col span={12}>
                <ListItem label="Última Parcela">
                  {formatCurrency(contract?.data.portionAmount)}
                </ListItem>
              </Col>
            </Row>
          </div>
        </Card>
      </>
    )
  }

  return (
    <div>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Detalhes do Contrato
      </ContentHeader>
      <ContentBody>
        <Tabs type="line">
          <TabPane tab="Geral" key="1">
            <GeneralTab />
          </TabPane>
          <TabPane tab="Oportunidades" key="2">
            <div style={{ height: 10 }}></div>
            <Button type="primary" onClick={showModal}>
              <PlusOutlined />
              Adicionar Oportunidade
            </Button>
            <Modal
              title="Nova Oportunidade"
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              centered
              width={1000}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="reset" onClick={handleReset}>
                  Reiniciar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                  Adicionar
                </Button>
              ]}
            >
              <OpportunityForm values={formValues} setValues={setFormValues} />
            </Modal>
            <div style={{ height: 20 }}></div>
            <Table
              dataSource={opportunity?.data}
              columns={columns}
              bordered
              pagination={{
                pageSize: pagination.limit,
                current: pagination.page,
                total: opportunity?.total,
                onChange: (page, limit) => handlePagination(page, limit || 10)
              }}
              rowKey={(row: any) => row.id}
            />
          </TabPane>
          <TabPane tab="Itens do Contrato" key="3">
            <Table
              dataSource={contractItem?.data}
              columns={itemsColumns}
              bordered
              rowKey={(row: any) => row.id}
            />
          </TabPane>
        </Tabs>
      </ContentBody>
    </div>
  )
}
